import { Component, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Helper } from '../../../../utils/helper';
import { CommonModule } from '@angular/common';
import { PinService } from '../../../../services/pin.service';
import { OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-pin',
    imports: [CommonModule],
    templateUrl: './pin.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './pin.component.scss'
})
export class PinComponent implements OnInit, OnDestroy {
  @Input() block: any | undefined;

  private _destroy$ = new Subject<void>();

  pins: any | undefined;

  // notifications for annotations
  notifications: Array<{
    xCords: number;
    yCords: number;
    pinId: string;
    blockID: string;
  }> = [];

  currentBlockId: string | undefined;

  constructor(private pinService: PinService) {
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  ngOnInit(): void {
    this.pinService.blockIdData$
      .pipe(takeUntil(this._destroy$))
      .subscribe((response) => {
        if (response) {
          this.currentBlockId = response;
        }
      });
    // if app is starting newPinData will be empty so take the init values from
    // the block input
    if (this.pins == undefined) {
      this.pins = this.block.notifications;
      this.pins = this.popEmptyPins(this.pins);
    }

    // any new change works through rxjs
    this.pinService.newPinData$
      .pipe(takeUntil(this._destroy$))
      .subscribe((response) => {
        // pop the pin from the array without cordinates
        response = this.popEmptyPins(response);

        if (response && this.currentBlockId == this.block.blockId) {
          this.pins = response;
        } else if (this.block?.notifications?.length == 0 && response?.null) {
          this.pins = [];
        }
      });
  }

  private popEmptyPins(response?: any): any {
    if (response) {
      response = Array.from(response);

      // pop the pin from the array without cordinates
      response = response?.filter(
        (pin: any) => !(pin.xCords === 0 && pin.yCords === 0)
      );

      return response;
    }
  }

  //drop a pin for annotations
  public onContainerClick(event: MouseEvent) {
    // check if the Ctrl key is held down
    if (!event.ctrlKey) {
      return; // do nothing if Ctrl is not held
    }

    event.stopPropagation();

    let pinId = Helper.generateIdHash(Date.now().toString());

    // Using event.currentTarget to reference the container
    const container = event.currentTarget as HTMLElement;
    const rect = container.getBoundingClientRect();
    const xCords = event.clientX - rect.left;
    const yCords = event.clientY - rect.top;

    const newNotification = {
      xCords,
      yCords,
      pinId: pinId,
      blockID: this.block.blockId,
    };
    this.notifications.push(newNotification);
    // console.log('This is the new notification', newNotification);

    // send data

    this.pinService.sendData(newNotification);
  }

  highlightNotification(event: MouseEvent): void {
    event.stopPropagation();

    // remove all highlighings on notifications if any exist
    const highlighted = document.querySelector(
      '.highlighted-notification'
    ) as HTMLElement | null;
    if (highlighted) {
      highlighted.classList.remove('highlighted-notification');
    }

    // get the pin using notification id
    const pin = event.target as HTMLElement;
    const notificationId = pin.dataset['notificationId'];

    // if notificationId exists hightlight it
    let notification: HTMLElement;
    if (notificationId) {
      notification = document.getElementById(notificationId) as HTMLElement;
      notification?.classList.add('highlighted-notification');
      // scroll element into view
      notification?.scrollIntoView({block: 'nearest', behavior: 'smooth'});
    }
  }
}
